import { request } from "../../../app/api-client/ApiClient";

/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */
export function listMantenimiento(dispatch, id, roles) {

    return request({
        url: `${process.env.REACT_APP_API_EVBI}/v1/mantenimiento/find/evbi/usuario/${id}/${roles}?page=0&size=30`,
        method: "GET",
    }, dispatch);
}

export function createMantenimiento(dispatch, Request) {
    let url = `${process.env.REACT_APP_API_EVBI}/v1/mantenimiento/crear`;
    return request({
        url: url,
        method: "POST",
        body: JSON.stringify(Request),
    }, dispatch);
}